import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "scroll-button-text"
};
import { ref, onMounted, onUnmounted, computed, watch } from '../../../../adapter-vue';
import { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../../common/Icon.vue';
import doubleArrowIcon from '../../../../assets/icon/double-arrow.svg';
import { getBoundingClientRect } from '@tencentcloud/universal-api';
import { JSONToObject } from '../../../../utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["scrollToLatestMessage"],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var emits = __emit;
    var messageList = ref([]);
    var currentConversationID = ref('');
    var currentLastMessageTime = ref(0);
    var newMessageCount = ref(0);
    var isScrollOverOneScreen = ref(false);
    var isExistLastMessage = ref(false);
    var isScrollButtonVisible = ref(false);
    var scrollButtonContent = computed(() => newMessageCount.value ? "".concat(newMessageCount.value).concat(TUITranslateService.t('TUIChat.条新消息')) : TUITranslateService.t('TUIChat.回到最新位置'));
    watch(() => [isScrollOverOneScreen.value, isExistLastMessage.value], () => {
      isScrollButtonVisible.value = isScrollOverOneScreen.value || isExistLastMessage.value;
      if (!isScrollButtonVisible.value) {
        resetNewMessageCount();
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      TUIStore.watch(StoreName.CHAT, {
        messageList: onMessageListUpdated,
        newMessageList: onNewMessageListUpdated
      });
      TUIStore.watch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CHAT, {
        messageList: onMessageListUpdated,
        newMessageList: onNewMessageListUpdated
      });
      TUIStore.unwatch(StoreName.CONV, {
        currentConversation: onCurrentConversationUpdated
      });
    });
    function isTypingMessage(message) {
      var _JSONToObject, _message$payload;
      return ((_JSONToObject = JSONToObject((_message$payload = message.payload) === null || _message$payload === void 0 ? void 0 : _message$payload.data)) === null || _JSONToObject === void 0 ? void 0 : _JSONToObject.businessID) === 'user_typing_status';
    }
    function onMessageListUpdated(newMessageList) {
      var _messageList$value, _messageList$value2;
      messageList.value = newMessageList || [];
      var lastMessage = (_messageList$value = messageList.value) === null || _messageList$value === void 0 ? void 0 : _messageList$value[((_messageList$value2 = messageList.value) === null || _messageList$value2 === void 0 ? void 0 : _messageList$value2.length) - 1];
      isExistLastMessage.value = !!(lastMessage && (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.time) < (currentLastMessageTime === null || currentLastMessageTime === void 0 ? void 0 : currentLastMessageTime.value));
    }
    function onNewMessageListUpdated(newMessageList) {
      if (Array.isArray(newMessageList) && isScrollButtonVisible.value) {
        newMessageList.forEach(message => {
          if (message && message.conversationID === currentConversationID.value && !message.isDeleted && !message.isRevoked && !isTypingMessage(message)) {
            newMessageCount.value += 1;
          }
        });
      }
    }
    function onCurrentConversationUpdated(conversation) {
      var _conversation$lastMes;
      if ((conversation === null || conversation === void 0 ? void 0 : conversation.conversationID) !== currentConversationID.value) {
        resetNewMessageCount();
      }
      currentConversationID.value = (conversation === null || conversation === void 0 ? void 0 : conversation.conversationID) || '';
      currentLastMessageTime.value = (conversation === null || conversation === void 0 || (_conversation$lastMes = conversation.lastMessage) === null || _conversation$lastMes === void 0 ? void 0 : _conversation$lastMes.lastTime) || 0;
    }
    // 消息列表向上的滚动高度大于一屏时，展示滚动到最新
    function judgeScrollOverOneScreen(_x) {
      return _judgeScrollOverOneScreen.apply(this, arguments);
    } // 载入最新的 messageSource
    function _judgeScrollOverOneScreen() {
      _judgeScrollOverOneScreen = _asyncToGenerator(function* (e) {
        if (e.target) {
          try {
            var _e$target, _e$target2, _e$detail, _e$target3, _e$detail2;
            var {
              height
            } = (yield getBoundingClientRect("#".concat((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id), 'messageList')) || {};
            var scrollHeight = ((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.scrollHeight) || ((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.scrollHeight);
            var scrollTop = ((_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.scrollTop) || ((_e$detail2 = e.detail) === null || _e$detail2 === void 0 ? void 0 : _e$detail2.scrollTop) || 0;
            // while scroll over one screen show this scroll button.
            if (scrollHeight - scrollTop > 2 * height) {
              isScrollOverOneScreen.value = true;
              return;
            }
            isScrollOverOneScreen.value = false;
          } catch (error) {
            isScrollOverOneScreen.value = false;
          }
        }
      });
      return _judgeScrollOverOneScreen.apply(this, arguments);
    }
    function resetMessageSource() {
      if (TUIStore.getData(StoreName.CHAT, 'messageSource') !== undefined) {
        TUIStore.update(StoreName.CHAT, 'messageSource', undefined);
      }
    }
    // reset newMessageCount
    function resetNewMessageCount() {
      newMessageCount.value = 0;
    }
    // 滚动到消息列表最底部
    function scrollToMessageListBottom() {
      resetMessageSource();
      resetNewMessageCount();
      emits('scrollToLatestMessage');
    }
    __expose({
      judgeScrollOverOneScreen,
      isScrollButtonVisible
    });
    return (_ctx, _cache) => {
      return _unref(isScrollButtonVisible) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "scroll-button",
        onClick: scrollToMessageListBottom
      }, [_createVNode(Icon, {
        width: "10px",
        height: "10px",
        file: _unref(doubleArrowIcon)
      }, null, 8, ["file"]), _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(scrollButtonContent)), 1)])) : _createCommentVNode("", true);
    };
  }
});